export const handleImageVideoBanner = () => {
    const banners = document.querySelectorAll('.image-or-video-banner');

    banners.forEach((banner) => {
        const containers: NodeListOf<HTMLElement> = banner.querySelectorAll('.banner-pool-widget__banner');

        containers.forEach((container) => {
            const imageContainer: HTMLElement | null = container.querySelector('.banner-image');
            const video: HTMLElement | null = container.querySelector('.image-video-widget__video-bg');
            if (!video) return;

            const hasVideo = video.querySelector('video, iframe');
            if (hasVideo) {
                container.classList.add('image-video-widget--with-video');
                imageContainer?.appendChild(video);
                }
            });
        });
};